import _ from "lodash";
import { createSelector } from "reselect";
import { RouteComponentProps } from "react-router-dom";
import { parse } from "query-string";

import { AuthNormalisedEntities } from "@auth/models";
import { getEntities as getAuthEntities } from "@auth/selectors";
import { FilesNormalisedEntities } from "@files/models";
import { getEntities as getFileEntities } from "@files/selectors";
import { MusicNormalisedEntities } from "@music/models";
import { getEntities as getMusicEntities, makeHydrateAlbum, makeHydrateTrack } from "@music/selectors";
import { SearchState as State } from "../models";

export const getSearchQuery = ({ search }: State) => search.query;
export const getSearchLastLoaded = ({ search: { response } }: State) =>
    response != null ? response.lastLoaded : null;
export const getSearchResponseQuery = ({ search: { response } }: State) =>
    response != null ? response.query : null;
export const getSearchAlbumIds = ({ search: { response } }: State) =>
    response != null ? response.albums : null;
export const getSearchTrackIds = ({ search: { response } }: State) =>
    response != null ? response.tracks : null;
export const getSearchRequestStarted = ({ search: { request } }: State) =>
    request != null ? request.started : null;

const getProps = (_state: State, props: RouteComponentProps<any>) => props;

export const getSearchIsLoading = createSelector(
    getSearchRequestStarted,
    (started: Date) => started != null,
);

export const getSearchResults = createSelector(
    getSearchAlbumIds,
    getSearchTrackIds,
    getMusicEntities,
    getFileEntities,
    getAuthEntities,
    (
        albumIds: number[],
        trackIds: number[],
        music: MusicNormalisedEntities,
        files: FilesNormalisedEntities,
        auth: AuthNormalisedEntities,
    ) => {
        const hydrateAlbum = makeHydrateAlbum(music, files, auth);
        const hydrateTrack = makeHydrateTrack(music, files, auth);
        return {
            albums: _.map(albumIds, (id) => hydrateAlbum(id)),
            tracks: _.map(trackIds, (id) => hydrateTrack(id)),
        };
    },
);

export const makeOnSearchPage = () => createSelector(
    getProps,
    (props: RouteComponentProps<any>) => props.location.pathname === "/search",
);

export const getQuery = (query: string) => {
    const obj = parse(query, { arrayFormat: "bracket" });
    if (Array.isArray(obj.q)) {
        // return obj.q.length > 0 ? obj.q[0] : "";
        // Looks like query-string will always populate the array with a first item.
        return obj.q[0];
    }
    return obj.q;
};

export const makeGetSearchQueryFromProps = () => createSelector(
    getProps,
    ({ location }: RouteComponentProps<any>) => {
        const q = getQuery(location.search);
        if (q != null) {
            return q;
        }
        return "";
    },
);
